import styled from 'styled-components';

export const AvatarContainer = styled.div`
  border-radius: 100%;
  display: flex;
  width: max-content;
  background: white;
`;
